import { PatchAppointmentStatus } from "@/services/fhir/appointment/PatchAppointmentStatus";
import { patchInviteStatus } from "../../invites/services/inviteTaskService";

/**
 * A afiliada cancela a PRÓPRIA reserva (recusada ou expirada): o Appointment vira
 * `cancelled` e o horário volta a ficar livre. Quem altera é a dona do Appointment
 * (sem depender de permissão da prestadora).
 * Convite ainda "requested" (expirado) é cancelado junto, em best effort.
 */
export async function cancelAffiliateBooking(params: {
  appointmentId: string;
  latestTask?: fhir5.Task;
}): Promise<void> {
  await PatchAppointmentStatus({ appointmentId: params.appointmentId, status: "cancelled" });
  const task = params.latestTask;
  if (task?.id && task.status === "requested") {
    try {
      await patchInviteStatus(task.id, "cancelled");
    } catch (error) {
      console.error("cancelAffiliateBooking.cancelInvite", error);
    }
  }
}
